const local_de = {
  ml: "ml",
  dl: "dl",
  cl: "cl",
  l: "l",
  pcs: "Stk",
  g: "g",
  dkg: "dkg",
  kg: "kg",
  none: "N/A",
  day: "Tag",
  hour: "Stunde",
  min: "Minute",

  sign_up: "Registrieren",
  login: "Anmelden",
  provide_first_name: "Bitte gib deinen Vornamen an",
  surname: "Nachname",
  provide_surname: "Bitte gib deinen Nachnamen an",
  email: "E-Mail-Adresse",
  provide_email: "Bitte gib deine E-Mail-Adresse an",
  quick_access_code: "Schnellcode",
  require_quick_access_code: "Erforderlich",
  provide_password: "Bitte gib dein Passwort ein",
  forgot_password: "Passwort vergessen?",
  need_sign_up: "Noch kein Konto?",
  registration: "Registrierung",
  register: "Registrieren",
  back_to_login: "Zurück zur Anmeldung",
  social_login: "oder mit Social-Media-Konto anmelden",
  email_already_in_use: "Diese E-Mail-Adresse wird bereits verwendet!",
  activation_email_sent:
    "Eine Aktivierungs-E-Mail wurde an {0} gesendet. Bitte überprüfe auch deinen SPAM-Ordner!",
  activation_email_sent2:
    "Eine Aktivierungs-E-Mail wurde an {0} gesendet. Bitte überprüfe auch deinen SPAM-Ordner!",
  password_reset_email_sent:
    "Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich an {0} gesendet!",
  password_reset_email_sent2:
    "Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich an %{email} gesendet!",
  confirm_account_deletion:
    "Bist du sicher, dass du dein Konto löschen möchtest?",
  account_deleted_successfully:
    "Dein Konto wurde erfolgreich gelöscht!",
  bad_password_request_token:
    "Ungültiger oder abgelaufener Link zum Zurücksetzen des Passworts! Bitte fordere einen neuen an!",
  password_reset_successfully:
    "Das neue Passwort wurde erfolgreich gesetzt!",
  missing_role:
    "Zugriff verweigert! Die erforderliche Berechtigung fehlt!",
  password_forgotten_text:
    "Bitte gib deine E-Mail-Adresse an. Wir senden dir einen Link zum Festlegen eines neuen Passworts.",
  register_first:
    "Bitte registriere dich zuerst, bevor du einen Drittanbieter-Login verwendest!",

  login_failed: "Anmeldung fehlgeschlagen! Falsche E-Mail oder Passwort!",
  communication_error:
    "Kommunikationsfehler mit dem Server (Fehlercode: {0})!",

  join: "Beitreten",
  occupy: "Belegen",
  ok: "OK",
  cancel: "Abbrechen",
  apply: "Anwenden",
  do_not_show_it_again: "OK, nicht mehr anzeigen",

  get_a_table: "Tisch bekommen",
  locked_get_a_table_one_table: "Tisch Nr. {0}\n{2} Personen",
  locked_get_a_table_more_tables: "{0} Tische\n{2} Personen",
  joined_get_a_table: "Beigetreten\ntisch\nNr. {0}",
  joined_not_authorized_get_a_table: "Beigetreten\naber nicht\ngenehmigt",
  let_other_to_join_your_table:
    "Erlaube anderen, deinem Tisch beizutreten",

  the_lead_customer_cannot_be_unapproved:
    "Du kannst den Organisator nicht ablehnen!",

  confirmation: "Bestätigung",
  warning: "Warnung",
  do_you_want_to_be_the_organizer:
    "Möchtest du wirklich der Organisator sein?",
  approvedBy: "Genehmigt von {0}",
  paidBy: "Bezahlt von {0}",
  waiting_for_approval_from_somebody:
    "Warte auf Genehmigung!",
  your_mate_is_not_intending_to_pay_his_bill:
    "Dein Begleiter beabsichtigt nicht, seine Rechnung zu bezahlen!",
  your_mate_intends_to_pay_his_bill:
    "Dein Begleiter möchte seine Rechnung bezahlen, erlaubt dir aber trotzdem einzuladen!",
  your_mate_wants_to_pay:
    "Dein Begleiter möchte selbst bezahlen und erlaubt niemand anderem dies!",
  shared_table_tooltip:
    "Die verbleibenden freien Plätze an diesem Tisch können von anderen belegt werden!",
  request_from: "Anfrage von {0}",
  message_from: "Nachricht von {0}",
  error_message: "Fehlermeldung",
  warning_message: "Warnhinweis",
  question: "Frage",
  suggestion: "Vorschlag",
  information: "Information",
  success_message: "Erfolg",
  organizer_request_denied:
    "Ich bin nicht einverstanden, dass du Organisator wirst!",
  organizer_request:
    "Bitte erlaube mir, die Rolle des Organisators zu übernehmen!",
  organizer_confirmation:
    "Du bist jetzt der Organisator!",
  let_me_pay: "Lass mich bezahlen",
  approve_joining: "Beitritt genehmigen",
  reject_joining: "Beitritt ablehnen",
  reject_paying: "Ich möchte nicht bezahlen",
  i_am_paying: "Ich bezahle",
  does_not_agree_invite:
    "{0} ist nicht einverstanden, dass du bezahlst!",
  do_you_want_to_leave:
    "Möchtest du diesen Tisch wirklich verlassen?",
  lock_another_table: "Anderen Tisch belegen",
  unlock_table: "Tisch verlassen",
  scanToAddTable: "Anderen Tisch belegen",
  scanToChangeTable: "Ich wechsle zu diesem Tisch",
  somebody: "Jemand",

  sending: "Passwort-E-Mail senden",
  password_reset: "Neues Passwort setzen",
  ask_password_reset: "Passwort zurücksetzen",
  password_forgotten: "Passwort vergessen",

  message_already_joined:
    "Du bist bereits diesem Tisch beigetreten!",
  message_nobody_to_join:
    "Es gibt niemanden, dem du beitreten könntest!",
  message_nobody_allows_joining:
    "Momentan erlaubt niemand das Beitreten an diesem Tisch!",
  message_do_you_want_to_switch_table:
    "Du bist bereits an Tisch {0}. Möchtest du zu Tisch {1} wechseln?",

  "message_do_you_want_to_join_table_with_approval": "Der Tisch ist bereits besetzt und andere können nur nach deiner Zustimmung beitreten! Möchtest du beitreten?",
  "message_do_you_want_to_join_table_without_approval": "Der Tisch ist bereits besetzt, aber ein Beitritt ist ohne weitere Zustimmung erlaubt! Möchtest du beitreten?",
  "massage_you_do_not_want_to_pay": "In den Einstellungen hast du angegeben, dass du nicht bezahlen möchtest! Ändere diese Einstellung, falls du doch bezahlen willst!",
  "message_you_can_join_only_one_company": "Du hast bereits einer Tischgruppe beigetreten und kannst nur innerhalb derselben Gesellschaft den Tisch wechseln!",
  "choose_between_joining_or_occupying_a_table": "Möchtest du den Tisch besetzen oder stattdessen einer bestehenden Gruppe beitreten?",
  "this_table_is_occupied": "Dieser Tisch ist besetzt und derzeit erlaubt niemand einen Beitritt!",
  "this_table_is_occupied_by_multiple_parties_join_directly": "An diesem Tisch sitzen mehrere Gruppen! Bitte frage einen Teilnehmer, dir einen QR-Code in der EatWithMe-App zu zeigen, damit klar ist, welcher Gruppe du beitreten möchtest!",
  "would_you_create_a_picture_as_well": "Füge auch ein Foto hinzu! Das erleichtert später die Identifizierung!",
  "message_do_you_really_want_to_leave_the_table": "Willst du den Tisch wirklich verlassen?",
  "message_do_you_really_want_to_unlock_table_not_yourself": "Verlässt diese Person wirklich den Tisch?",
  "message_do_you_really_want_to_unlock_table": "Willst du den Tisch wirklich verlassen?",
  "are_you_sure_you_want_to_pay_for_yourself": "Bist du sicher, dass du für dich selbst anstelle von {0} bezahlen möchtest?",
  "are_you_sure_you_want_to_pay_instead": "Bist du sicher, dass du für {1} anstelle von {0} bezahlen möchtest?",
  "are_you_sure_you_want_to_pay_instead_and_more": "Bist du sicher, dass du für {1} und {2} weitere Personen anstelle von {0} bezahlen möchtest?",
  "reject_invite": "{0} erlaubt dir nicht, für sein/ihr Essen zu bezahlen!",

  "qr_code_generation_failed": "Der QR-Code konnte nicht gelesen werden! Noch einmal versuchen?",

  "leave_table": "Tisch verlassen",
  "leave_the_table": "Den Tisch verlassen",
  "message_table_join_cancelled": "Du hast den Tisch erfolgreich verlassen!",
  "message_subprofile_join_cancelled": "{0} wurde von den Teilnehmern entfernt!",
  "profileUpdatedSuccessfully": "Dein Profil wurde erfolgreich aktualisiert",

  "first_name": "Vorname",
  "family_name": "Nachname",
  "password": "Passwort",

  "new_subprofile": "Neues Unterprofil hinzufügen (z.B. für dein Kind)",
  "profile_picture": "Profilbild",
  "my_favorites": "Meine Favoriten",
  "favorite_of": "Favorit von",
  "subprofiles": "Unterprofile",
  "subprofile_tooltip": "Du kannst Unterprofile für Personen (wie deine Kinder oder Eltern) erstellen, die kein E-Mail-Konto haben oder keinen Zugriff darauf!<br/><br/>So kannst du später separat für sie bestellen, ohne dass sie ein eigenes Konto benötigen!",
  "my_favorites_tooltip": "Nach ihrer <b>Bestätigung</b> kannst du deine Favoriten ohne weitere Zustimmung zu deinem Tisch hinzufügen!<br/><br/>Ebenso können sie deinem Tisch ohne weitere Zustimmung beitreten!",
  "favorite_of_tooltip": "Nach deiner <b>Bestätigung</b> können sie dich ohne weitere Zustimmung an ihren Tisch hinzufügen!<br/><br/>Ebenso kannst du ihrem Tisch ohne weitere Zustimmung beitreten!",

  "couldNotFindCustomer": "Es wurde kein Kunde mit dieser E-Mail-Adresse gefunden!",
  "subprofileAlreadyUsedAsTableMate": "{0} war bereits Teil eines Events! Bist du sicher, dass du {0} löschen möchtest?",

  "favorite_approved_tooltip": "Bestätigt",
  "favorite_pending_tooltip": "Ausstehende Bestätigung",
  "placeholder_add_an_email": "E-Mail-Adresse eingeben...",
  "placeholder_add_a_name": "Namen eingeben...",
  "subprofileAlreadyExists": "Das Unterprofil existiert bereits!",
  "subprofile": "Unterprofil",
  "name": "Name",
  "do_you_really_want_to_delete_your_favoriteOf": "Möchtest du wirklich die Favoritenanfrage von <b>{0}</b> löschen?",
  "do_you_really_want_to_delete_your_favorite": "Möchtest du <b>{0}</b> wirklich aus deinen Favoriten entfernen?",
  "do_you_really_want_to_delete_your_subprofile": "Möchtest du das Unterprofil <b>{0}</b> wirklich löschen?",
  "do_you_really_want_to_unjoin_your_subprofile": "Möchtest du <b>{0}</b> wirklich aus den Teilnehmern entfernen?",
  "message_do_you_really_want_to_change_table": "Möchtest du {0} wirklich an Tisch {1} setzen?",

  "thisEmailIsAlreadyBoundWithAnotherAccount": "Diese E-Mail-Adresse ist bereits mit einem anderen Konto verknüpft!",

  "people_tab": "Tischnachbarn",
  "tables_tab": "Meine Tische",
  "table_tab": "Mein Tisch",
  "settings_tab": "Einstellungen",

  "paying": "Zahlen",
  "wants_to_pay": "Will bezahlen",
  "i_do_not_pay": "Ich bezahle nicht",
  "i_could_pay": "Ich könnte bezahlen",
  "i_want_to_pay": "Ich möchte bezahlen",
  "i_will_pay": "Ich werde bezahlen",
  "i_am_invited": "Ich bin eingeladen",

  "paid_for": "Tischnachbarn",
  "i_pay_for": "Ich zahle für sie",
  "tableMates": "Unklar, wer für sie zahlt",
  "joiningTableMates": "Möchten beitreten",
  "your_joined_tables": "Mein beigetretener Tisch",
  "your_tables": "Meine Tische",

  "add_sub_profile": "Unterprofil hinzufügen",
  "add_participant": "Neue Teilnehmer hinzufügen",
  "close": "Schließen",
  "scan_to_join_table": "Scannen, um Tisch {0} beizutreten",
  "add_additional_participants_as_subprofiles": "Unterprofile",
  "add_additional_participants_without_table": "Teilnehmer ohne Tisch",
  "add_mate": "Hinzufügen",

  "table_picker_title": "Wähle einen Tisch",
  "table_picker": "Tischnr. {0}",
  "my_table_picker": "Tischnr. {0} (Mein Platz)",
  "my_mate_picker": "{0} (Ich selbst)",
  "mate_picker": "{0}",
  "everybody": "Alle {0}",
  "allTables": "Alle Tische",
  "i_pay_for2": "Alle {0}, für die ich zahle",

  "order": "Bestellen",
  "orderMeals": "Speisen",
  "orderDrinks": "Getränke",
  "unknown": "???",
  "byCustomer": "Nach Person",
  "byDrinkOrMeal": "Nach Speise oder Getränk",
  "byDrink": "Nach Getränk",
  "byMeal": "Nach Speise",

  "do_you_really_want_to_delete_all_new_orders": "Möchtest du wirklich alle neuen Bestellungen löschen?",
  "do_you_really_want_to_delete_all_orders": "Möchtest du wirklich alle neuen, nicht bestätigten Bestellungen löschen?",
  "please_choose_mate_for_this_order": "{0} {1} {2} – Für wen möchtest du bestellen?",
  "select": "Auswählen",

  "order_items": "Anzahl der Artikel:",
  "people_count": "Personenzahl:",

  "do_you_really_want_to_submit_all_new_orders": "Möchtest du wirklich alle neuen Bestellungen absenden?",

  "show_table_qr": "Tische organisieren",

  "seats_wanted": "Für wie viele Personen:",

  "placeholder": "Platzbelegung",
  "my_profile": "Mein Profil",

  "unlocking_not_possible_there_are_pending_orders": "Die Person kann den Tisch nicht verlassen. Es gibt offene Bestellungen!",
  "unjoining_somebody_not_possible_there_are_pending_orders": "Du kannst den Tisch nicht verlassen, solange es Bestellungen gibt, die von jemand anderem für dich bezahlt werden!",
  "unjoining_yourself_not_possible_there_are_pending_orders": "Du kannst den Tisch nicht verlassen, solange du offene Bestellungen hast!",
  "unjoining_somebody_not_possible_paying_for_others": "Die Person kann den Tisch nicht verlassen. Sie bezahlt für andere!",

  "comment": "Kommentar",
  "enter_comment": "Kommentar eingeben (optional)",
  "this_item_was_originally_ordered_by": "Dieser Artikel wurde ursprünglich von {0} bestellt!",
  "this_item_was_ordered_by": "Dieser Artikel wurde von {0} ausgewählt!",
  "cancelled": "Storniert",
  "selected": "Ausgewählt",
  "ordered": "Bestellt",
  "accepted": "Angenommen",
  "producing": "In Zubereitung",
  "delivering": "Wird geliefert",
  "delivered": "Geliefert",
  "paid": "Bezahlt",

  "rejection_reason": ["Falsch ausgewählt", "Nicht möglich", "Ausverkauft", "Nicht verfügbar", "Wurde nicht zubereitet", "Zu spät zubereitet"],

  "timing": "Zeitpunkt",
  "timing_inherit": "Übernehmen",
  "timing_asap": "So bald wie möglich",
  "timing_appetizer": "Vorspeise / Suppe",
  "timing_maincourse": "Zwischengang",
  "timing_desert": "Hauptgang",
  "timing_last": "Dessert",

  "for_whom": "Für wen",

  "unknown_person": "Person {0}",

  "additions": "Zusätzliche Zutaten oder Toppings",
  "enter_additions": "Zusätzliche Zutaten oder Toppings hinzufügen",
  "inherited_additions": "Übernommene Zutaten oder Optionen",
  "noResultsMessageText": "Keine Ergebnisse gefunden für „%s“",
  "options": "Optionen",

  "reload_page": "Neu laden",
  "timeout": "Zeitüberschreitung",
  "server_unavailable": "Kommunikation mit dem Server fehlgeschlagen!",
  "error_code_500": "Interner Serverfehler",
  "error_code_400": "Ungültige Anfrage",
  "continue": "Ignorieren und fortfahren",
  "modify": "Ändern",
  "delete": "Löschen",
  "order_cannot_be_deleted": "Bestellung kann nicht mehr gelöscht werden",
  "orders_only_in_selected_or_ordered_state_can_be_deleted": "Bestellungen können nur im Status „ausgewählt“ oder „bestellt“ gelöscht werden!",
  "left_the_table": "hat den Tisch verlassen",
  "deleted_or_not_found": "Gelöscht oder nicht gefunden",

  "qr_code": "QR-Code",
  "person": "Person",

  "do_you_really_want_to_quit_pending_orders": "Willst du wirklich aufhören? Es gibt offene Bestellungen!",
  "quantity": "Menge",
  "paying_online": "Online-Zahlung läuft...",

  "feedback": {
    "label": "Feedback senden",
    "header": "Feedback senden",
    "nextLabel": "Weiter",
    "reviewLabel": "Überprüfen",
    "sendLabel": "Senden",
    "closeLabel": "Schließen",
    "messageSuccess": "Dein Feedback wurde erfolgreich gesendet.",
    "messageError": "Beim Senden des Feedbacks ist ein Fehler aufgetreten.",
    "pleaseDescribe": "Bitte beschreibe das aufgetretene Problem",
    "issue": "Das Problem",
    "blackout": "Schwärzen",
    "highlight": "Hervorheben",
    "highlight_or_blackout": "Wichtige Informationen hervorheben oder schwärzen",
    "typeMessagePlaceholder": "Nachricht hier eingeben..."
  },

  "help": {
    "next": "Weiter",
    "back": "Zurück",
    "done": "Fertig",
    "skip": "Überspringen"
  },

  "nameformat": "{1} {0}",
  "service_fee": "Servicegebühr",

  "daysOfWeek": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  "monthNames": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  "server_restart": "Der Server wird gerade aktualisiert. Bitte warte, bis die Verbindung wiederhergestellt ist!",
  "email_not_associated_with_an_account": "Diese E-Mail ist keinem Konto zugeordnet",
  "the_chosen_restauarant_online_services_seems_to_be_unavailable": "{0} ist derzeit nicht verfügbar!",
  "phone": "Telefon",
  "address": "Adresse",
  "town": "Stadt",
  "country": "Land",
  "postcode": "PLZ",
  "allDay": "ganztägig",
  "download_progress": "Upgrade läuft ({0}%)",
  "installing_update": "Update wird installiert",
  "new_version_is_available": "Es ist eine neue Version der Anwendung verfügbar!",
  "applelogin": "Mit Apple anmelden",
  "facebooklogin": "Mit Facebook anmelden",
  "door": "Stockwerk/Tür",
  "consent_successfull": "Danke für deine Zustimmung",
  "update_successfull": "Update erfolgreich",
  "consent_withdrawal_successfull": "Du hast deine Zustimmung zur Datenverarbeitung widerrufen! Deine personenbezogenen Daten wurden gelöscht!",
  "switch_back_to_live": "Der Hauptserver ist wieder verfügbar! Zurückschalten!",
  "switch_to_backup": "Der Hauptserver ist derzeit nicht verfügbar! Zum Backup-Server wechseln!",
  "access_denied": "Die Anmeldung war erfolgreich, aber du hast keinen Zugriff auf die Umgebung. Kontaktiere uns unter support@eatwithme.online, wenn du denkst, dass dies ein Fehler ist.",
  "pay_later": "Später bezahlen",
  "activation_code": "Aktivierungscode",
  "bad_activation_code": "Falscher oder abgelaufener Aktivierungscode",
  "activate": "Aktivieren",
  "activation": "Aktivierung",
  "no_internet": "Keine Internetverbindung",
  "request": "Anfrage",
  "please_perform_ntak_registration": "Bitte führe die NTAK-Registrierung durch!",
  "addToCart": "In den Warenkorb",
  "states": {
    "cancelled": "Storniert",
    "ordered": "Bestellt",
    "accepted": "Angenommen",
    "producing": "In Zubereitung",
    "ready": "Fertig",
    "delivering": "Wird geliefert",
    "delivered": "Geliefert"
  },
  "selected_items": "{0} ausgewählte Artikel",
  "for_takeaway": "Zum Mitnehmen",
  "localConsumption": "Vor Ort essen",
  "takeawayConsumption": "Mitnehmen",
  "payit": "Zur Zahlung",
  "cancelAll": "Alle Bestellungen stornieren",
  "payingWithTerminal": "Kartenzahlung läuft",
  "inactivity": "Aufgrund von Inaktivität wird die Bestellung in {0} Sekunden abgebrochen.",
  "paymentSuccessMessage": "Deine Zahlung war erfolgreich!\r\nDeine Bestellnummer lautet: #{0}\r\nVielen Dank für deine Bestellung!",
  "kioskOrderHere": "Hier bestellen – kein Anstehen!",
  "kioskOrderHereHu": "Ne várj a sorban, rendelj itt!",
  "kioskOrderHereEn": "Order here, no waiting in line!",
  "printing_receipt": "Deine Zahlung war erfolgreich!\r\nDeine Bestellnummer lautet: #{0}\r\n\r\nBeleg wird gedruckt...",
  "printing_receipt_error": "Deine Zahlung war erfolgreich!\r\nDeine Bestellnummer lautet: #{0}\r\n\r\nBelegdruck fehlgeschlagen.\r\nFehler: {1}\r\n\r\nBitte kontaktiere das Personal!",
  "selectPaymentMethod": "Zahlungsmethode auswählen",
  "payCash": "Bar bezahlen",
  "payCard": "Mit Karte bezahlen",
  "cashPaymentMessage": "Bitte zahle an der Kasse!\r\nDeine Bestellnummer lautet: #{0}\r\nVielen Dank für deine Bestellung!",
  "Napnyitás kötelez?": "Kassenöffnung erforderlich!"
};
export default local_de;
